import { config, DEFAULT_IDENTIFICATION_RULES, IdentificationRule } from '../config';
import { apiFetch, getAuthToken } from './apiClient';

interface SeedRulesResponse {
  data: IdentificationRule[];
  total: number;
}

/**
 * Identification rules, read from the Harbour API (`GET /v1/seed/rules`) — the
 * single source of truth, seeded via `harbour seed rules`. Falls back to the
 * bundled defaults only in mock mode (local dev without a session).
 */
export const getIdentificationRules = async (): Promise<IdentificationRule[]> => {
  if (!config.api.useMock && getAuthToken()) {
    const result = await apiFetch<SeedRulesResponse>('/seed/rules');
    return result.data;
  }
  return DEFAULT_IDENTIFICATION_RULES;
};

/**
 * File-type options for filters/badges, derived from the identification rules
 * (their distinct file types, plus UNKNOWN for unmatched assets).
 */
export const getFileTypes = async (): Promise<string[]> => {
  const rules = await getIdentificationRules();
  return [...new Set([...rules.map((r) => r.fileType), 'UNKNOWN'])].sort();
};
